const mEditionBillingMyPayments = {
  mEditionBillingMyPayments: {
    buttonSecondary: {
      download: {
        text: 'Exportar',
        subText: 'Formato'
      },
      filterText: 'Filtros Avanzados'
    },

    table: {
      thDate: 'Fecha',
      thDetail: 'Detalle',
      thDiscount: 'Desc.',
      thInvoice: 'Ver',
      thMethod: 'Medio',
      thToPay: 'A Pagar',
      thTotal: 'Total',
      thType: 'Comp.'
    },

    tooltips: {
      actions: 'Acciones',
      invoice: 'Ver Comprobante',
      restart: 'Actualizar'
    }
  }
}

export default mEditionBillingMyPayments
